import QbLogo, { QbLogoSize } from '../Icons/QbLogo';

type Props = {
  size?: QbLogoSize;
};

const LoadingAnimation = ({ size = 'md' }: Props) => {
  return (
    <div className="animate-spin">
      <QbLogo size={size} />
    </div>
  );
};

export default LoadingAnimation;
